import DonMessage from './message'
const Message = new DonMessage()
function transformData(data) {
  var arr = []
  var indexObj = {}
  data.forEach((row) => {
    var pname = row.provincename || '其它'
    var index = indexObj[pname]
    var pro = arr[index]
    if (index === undefined) {
      pro = {
        name: pname,
        id: row.pid || -1,
        firstword: row.provincefirstwordchar || 'Z',
        total: 0,
        online: 0,
        type: 'pro',
        children: []
      }
      indexObj[pname] = arr.length
      arr.push(pro)
    }
    pro.children.push({
      name: row.cityname || '其它',
      id: row.cityid || -1,
      firstword: row.cityfirstword || 'Z',
      total: row.totalcount,
      type: 'city',
      pid: row.pid || -2,
      pageNum: 1,
      pageSize: 5,
      children: [{ show: false }]
    })
    pro.total += row.totalcount
  })
  sort(arr)
  arr.forEach((pro) => {
    sort(pro.children)
  })
  return arr
}
function sort(arr) {
  arr.sort(function(a, b) {
    if (a.id == '0' || a.id == '1') {
      return 1
    } else if (b.id == '0' || b.id == '1') {
      return -1
    }
    return a.firstword == b.firstword
      ? (b.total - a.total)
      : a.firstword > b.firstword ? 1 : -1
  })
}

function transfromCarTypeData(data) {
  var arr = []
  data.forEach(row => {
    arr.push({
      name: row.cartypename,
      pageNum: 1,
      pageSize: 5,
      pid: -2,
      id: row.cartypeid,
      total: row.totalcount,
      type: 'city',
      children: [{ show: false }]
    })
  })
  return arr
}
// 判断起始时间是否大于结束时间
function beginTimeAndEndTime(obj) {
  const startTime = new Date(obj.begintime).getTime()
  const endTime = new Date(obj.endtime).getTime()
  if (startTime > endTime) {
    Message.error({
      message: obj.message,
      duration: 2 * 1000
    })
    return false
  } else {
    return true
  }
}
// 数组对象去重
function duplicateRemoval(arr, k) {
  const obj = {}
  arr = arr.reduce((cur, next) => {
    if (!obj[next[k]]) {
      obj[next[k]] = true
      if (obj[next[k]]) {
        cur.push(next)
      }
    }
    return cur
  }, [])
  return arr
}
// data是json对象，Name是根据什么字段去重
function filterJSONByName(data, Name) {
  var dest = []
  for (var i = 0; i < data.length; i++) {
    var ai = data[i]
    if (i == 0) {
      dest.push(ai)
    } else {
      var filterData = dest.filter(function(e) {
        return e[Name] == ai[Name]
      })
      if (filterData.length == 0) {
        dest.push(ai)
      }
    }
  }
  return dest
}

export {
  transformData,
  transfromCarTypeData,
  beginTimeAndEndTime,
  duplicateRemoval,
  filterJSONByName
}
